import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Reorder Confirm Location</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
